import Vue from 'vue'
import PayPal from 'vue-paypal-checkout'

Vue.component('paypal-checkout', PayPal)
